import { render, staticRenderFns } from "./AdministrativeStatus.vue?vue&type=template&id=5841f09b&"
import script from "./AdministrativeStatus.vue?vue&type=script&lang=js&"
export * from "./AdministrativeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports